import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styles from "./TimeTracking.module.css";
import { TableLoaderSmall } from "../../../components/LoaderC";
import { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import { toast } from 'react-smart-toaster';

dayjs.extend(customParseFormat);

const timeToDecimal = (time) => {
    const parsed = dayjs(time, ['HH:mm:ss', 'h:mm A', 'H:mm']);

    const hours = parsed.hour();
    const minutes = parsed.minute();

    return hours + minutes / 60;
}
const formatMinutesToHM = (totalMinutes) => {
    if (totalMinutes === 0)
        return `-`;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    if (hours === 0) return `${minutes}m`;
    if (minutes === 0) return `${hours}h`;

    return `${hours}h ${minutes}m`;
}

const toP = (h, base = 8, span = 14) => Math.max(0, Math.min(100, ((h - base) / span) * 100));

const DayModal = ({ setIsModalOpen, selectedEmp, selectedDay, setLoading, updateTimeTracking }) => {
    const { getAccessTokenSilently } = useAuth0();

    const [shiftOpen, setShiftOpen] = useState(false);
    const [shiftStart, setShiftStart] = useState(dayjs(selectedDay?.checkin_time, 'HH:mm:ss').format('HH:mm') || "09:00");
    const [shiftEnd, setShiftEnd] = useState(dayjs(selectedDay?.checkout_time, 'HH:mm:ss').format('HH:mm') || "17:00");
    const [saved, setSaved] = useState(false);

    const schedL = toP(timeToDecimal(selectedEmp?.checkin_time));
    const schedW = toP(timeToDecimal(selectedEmp?.checkout_time)) - schedL;
    const ciL = toP(timeToDecimal(selectedDay?.checkin_time) || timeToDecimal(selectedEmp?.checkin_time));
    const workedW = toP(timeToDecimal(selectedDay?.checkout_time) || dayjs().format('HH:mm:ss')) - ciL;

    const openShift = () => {
        setShiftOpen(v => !v);
    }

    function handleApply() {
        setSaved(true);
        setTimeout(() => setSaved(false), 1800);
    }

    const declineOT = async (itemId) => {
        setLoading(true);
        setIsModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/time-tracking/ot-declined/' + itemId, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);
            updateTimeTracking(response.data.data);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    const approveOT = async (itemId) => {
        setLoading(true);
        setIsModalOpen(false);

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

        return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/time-tracking/ot-approved/' + itemId, { start: dayjs(shiftStart, 'HH:mm').format('HH:mm:ss'), end: dayjs(shiftEnd, 'HH:mm').format('HH:mm:ss') }, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);
            updateTimeTracking(response.data.data);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<div className={`${styles.modalOverlay}`} onClick={e => { if (e.target === e.currentTarget) setIsModalOpen(false); }}>
        <div className={`${styles.modal}`}>

            <div className={`${styles.modalHead}`}>
                <div className={`${styles.mhLeft}`}>
                    <div className={`${styles.av} ${styles.avPl}`} style={{ width: 34, height: 34, fontSize: 10, flexShrink: 0 }}>
                        {selectedEmp?.user_image_url ? <img src={selectedEmp?.user_image_url} alt="User Avatar" style={{ maxHeight: '28px', maxWidth: '28px' }} /> : selectedEmp?.initial}
                    </div>
                    <div>
                        <div className={`${styles.modalName}`}>{selectedEmp.name}</div>
                        <div className={`${styles.modalDate}`}>{dayjs(selectedDay?.date).format('ddd D, MMM YYYY')}</div>
                    </div>
                </div>
                <button className={`${styles.modalClose}`} onClick={(e) => setIsModalOpen(false)} aria-label="Close">✕</button>
            </div>

            <div className={`${styles.timelineWrap}`}>
                <div className={`${styles.tlLabel}`}>Shift timeline</div>
                <div className={`${styles.tlBarWrap}`}>
                    <div className={`${styles.tlTrack}`} />
                    <div className={`${styles.tlSched}`} style={{ left: `${schedL}%`, width: `${schedW}%` }} />
                    <div className={`${styles.tlWorked}`} style={{ left: `${ciL}%`, width: `${workedW}%` }} />
                </div>
                <div className={`${styles.tlTimes}`}>
                    <span>8 AM</span><span>3 PM</span><span>10 PM</span>
                </div>
                <div className={`${styles.tlCiLbl}`}>
                    <span className={`${styles.tlBadge} ${styles.tlBadgeIn}`}>{dayjs(selectedDay?.checkin_time, 'HH:mm:ss').format('hh:mm A')}</span>
                    <span className={`${styles.tlArrow}`}>→</span>
                    {selectedDay?.checkout_time ? <span className={`${styles.tlBadge} ${styles.tlBadgeOut}`}>{dayjs(selectedDay?.checkout_time, 'HH:mm:ss').format('hh:mm A')}</span> : dayjs(selectedDay?.date).isSame(dayjs(), "day") ? <span className={`${styles.tlBadge} ${styles.tlBadgeProg}`}>Now</span> : <span className={`${styles.tlBadge} ${styles.tlBadgeMiss}`}>No out</span>}
                    <span className={`${styles.tlDur}`}>{formatMinutesToHM(selectedDay?.working_time)} Worked</span>
                </div>
            </div>

            <div className={`${styles.modalBody}`}>
                <div className={`${styles.infoRow}`}>
                    <span className={`${styles.irLbl}`}>⏱ Scheduled shift</span>
                    <span className={`${styles.irVal}`}>{selectedEmp?.checkin_time + " - " + selectedEmp?.checkout_time}</span>
                </div>
                <div className={`${styles.infoRow}`}>
                    <span className={`${styles.irLbl}`}>◎ Shift target</span>
                    <span className={`${styles.irVal}`}>{formatMinutesToHM(selectedDay?.shift_minutes)}</span>
                </div>
                <div className={`${styles.infoRow} ${styles.infoRowLast}`}>
                    <span className={`${styles.irLbl}`}>⌛ Total worked</span>
                    <span className={selectedDay?.is_ot_approved > 0 ? `${styles.irVal} ${styles.irOt}` : selectedDay?.late ? `${styles.irVal} ${styles.irLate}` : `${styles.irVal} ${styles.irOk}`}>{formatMinutesToHM(selectedDay?.regular_minutes + selectedDay?.ot_time)}</span>
                </div>
            </div>

            {selectedDay?.is_ot_approved === 1 && (<>
                <div className={`${styles.otBox}`}>
                    <div className={`${styles.otBoxTitle}`}>⚠ Overtime detected</div>
                    <div className={`${styles.otAmount}`}>+{formatMinutesToHM(selectedDay?.ot_time)} overtime</div>
                    <div className={`${styles.otDesc}`}>
                        Worked {formatMinutesToHM(selectedDay?.ot_time)} beyond the {formatMinutesToHM(selectedDay?.shift_minutes)} scheduled shift.
                        Approve to confirm paid overtime, or decline to mark as unpaid.
                    </div>
                </div>

                <div className={`${styles.shiftSection}`}>
                    <button className={`${styles.shiftToggleBtn}`} onClick={openShift}>
                        ✏ {shiftOpen ? "Hide shift editor" : "Adjust shift hours (optional)"}
                    </button>
                    {shiftOpen && (
                        <div className={`${styles.shiftEditBody}`}>
                            <div className={`${styles.seLbl}`}>Override shift hours</div>
                            <div className={`${styles.shiftInputs}`}>
                                <input className={`${styles.shiftInput}`} type="time" value={shiftStart} onChange={e => setShiftStart(e.target.value)} aria-label="Shift start" />
                                <span className={`${styles.shiftSep}`}>–</span>
                                <input className={`${styles.shiftInput}`} type="time" value={shiftEnd} onChange={e => setShiftEnd(e.target.value)} aria-label="Shift end" />
                                <button className={`${styles.applyBtn} ${saved ? styles.applyBtnSaved : ""}`} onClick={handleApply}>
                                    {saved ? "Saved ✓" : "Apply"}
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </>)}

            <div className={`${styles.modalFooter}`}>
                {selectedDay?.is_ot_approved > 1 && <>
                    <span className={`${styles.footerStatus} ${selectedDay?.is_ot_approved === 2 ? styles.footerOk : styles.footerNo}`}>
                        {selectedDay?.is_ot_approved === 2 && "✓ OT Approved"}
                        {selectedDay?.is_ot_approved === 3 && "✕ OT Declined"}
                    </span>
                    <button className={`${styles.btnSecondary}`} onClick={(e) => setIsModalOpen(false)}>Close</button>
                </>}
                {selectedDay?.is_ot_approved === 1 && <>
                    <button className={`${styles.btnDanger}`} onClick={(e) => declineOT(selectedDay?.id)}>Decline OT</button>
                    <button className={`${styles.btnPrimary}`} onClick={(e) => approveOT(selectedDay?.id)}>✓ Approve OT</button>
                </>}
                {selectedDay?.is_ot_approved === 0 && <button className={`${styles.btnSecondary}`} onClick={(e) => setIsModalOpen(false)}>Close</button>}
            </div>

        </div>
    </div >
    );
}

function DayViewRow({ item, index, setIsModalOpen, setSelectedEmp, setSelectedDay }) {
    let classN = `${styles.av}`;

    if (index % 5 === 0) {
        classN = `${styles.av} ${styles.avPl}`;
    }
    if (index % 5 === 1) {
        classN = `${styles.av} ${styles.avTw}`;
    }
    if (index % 5 === 2) {
        classN = `${styles.av} ${styles.avCh}`;
    }
    if (index % 5 === 3) {
        classN = `${styles.av} ${styles.avMj}`;
    }
    if (index % 5 === 4) {
        classN = `${styles.av} ${styles.avRl}`;
    }

    let timeTracking = item?.timeTracking[0];

    if (item?.working_days_arr.includes(dayjs().format("ddd")) && dayjs(timeTracking?.date).isSame(dayjs(), "day") && !timeTracking?.checkin_time)
        return (<tr className={`${styles.tbodyTr}`}>
            <td className={`${styles.tdEc}`}>
                <div className={`${styles.empWrap}`}>
                    <div className={`${classN}`}>{item?.user_image_url ? <img src={item?.user_image_url} alt="User Avatar" style={{ maxHeight: '28px', maxWidth: '28px' }} /> : item?.initial}</div>
                    <div>
                        <div className={`${styles.empName}`}>{item?.name}</div>
                        <div className={`${styles.empRole}`}>{item?.role}</div>
                    </div>
                </div>
            </td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dvStatusPending}`}>Pending</span></td>
        </tr>);

    if (!item?.working_days_arr.includes(dayjs().format("ddd")) || !timeTracking?.checkin_time)
        return (<tr className={`${styles.tbodyTr}`}>
            <td className={`${styles.tdEc}`}>
                <div className={`${styles.empWrap}`}>
                    <div className={`${classN}`}>{item?.user_image_url ? <img src={item?.user_image_url} alt="User Avatar" style={{ maxHeight: '28px', maxWidth: '28px' }} /> : item?.initial}</div>
                    <div>
                        <div className={`${styles.empName}`}>{item?.name}</div>
                        <div className={`${styles.empRole}`}>{item?.role}</div>
                    </div>
                </div>
            </td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.dh}`}>—</span></td>
            <td className={`${styles.td}`}><span className={`${styles.offLbl}`}>Day off</span></td>
        </tr>);

    const statusEl = !timeTracking?.checkout_time ? <span className={`${styles.dvStatusProg}`}>In progress</span> : timeTracking?.is_ot_approved === 2 ? <span className={`${styles.dvStatusOk}`}>OT approved</span> : timeTracking?.is_ot_approved === 3 ? <span className={`${styles.dvStatusOff}`}>OT declined</span> : timeTracking?.is_ot_approved === 1 ? <span className={`${styles.dvStatusOt}`}>Overtime ⚠</span> : item?.late ? <span className={`${styles.dvStatusLate}`}>Late start</span> : <span className={`${styles.dvStatusOk}`}>Complete</span>;

    let wageTotal = 0;

    if (item?.wage > 0 && timeTracking?.regular_minutes > 0) {
        wageTotal += (timeTracking?.regular_minutes / 60) * item?.wage;
    }

    if (item?.ot_wage > 0 && timeTracking?.approved_ot_time > 0) {
        wageTotal += (timeTracking?.approved_ot_time / 60) * item?.ot_wage;
    }

    wageTotal = Math.round(wageTotal);

    return (<tr className={`${styles.tbodyTr}`} style={{ cursor: "pointer" }} onClick={(e) => { setIsModalOpen(true); setSelectedEmp(item); setSelectedDay(timeTracking); }}>
        <td className={`${styles.tdEc}`}>
            <div className={`${styles.empWrap}`}>
                <div className={`${classN}`}>{item?.user_image_url ? <img src={item?.user_image_url} alt="User Avatar" style={{ maxHeight: '28px', maxWidth: '28px' }} /> : item?.initial}</div>
                <div>
                    <div className={`${styles.empName}`}>{item?.name}</div>
                    <div className={`${styles.empRole}`}>{item?.role}</div>
                </div>
            </div>
        </td>

        <td className={`${styles.td}`}>
            <span className={`${styles.dh} ${timeTracking?.late ? styles.dvTimeLate : ""}`}>{dayjs(timeTracking?.checkin_time, 'HH:mm:ss').format('hh:mm A')}</span>
        </td>

        <td className={`${styles.td}`}>{timeTracking?.checkout_time ? <span className={`${styles.dh}`}>{dayjs(timeTracking?.checkout_time, 'HH:mm:ss').format('hh:mm A')}</span> : dayjs(timeTracking?.date).isSame(dayjs(), "day") ? <span className={`${styles.dvInProgLbl}`}>in progress</span> : <span className={`${styles.dvInMissingLbl}`}>missing</span>}</td>

        <td className={`${styles.td}`}>
            {timeTracking?.break_mintes > 0 ? <span className={`${styles.dh}`}>{formatMinutesToHM(timeTracking?.break_mintes)}</span> : <span className={`${styles.dh}`}>—</span>}
        </td>

        <td className={`${styles.td}`}>
            {timeTracking?.regular_minutes > 0 ? <span className={`${styles.dh}`}>{formatMinutesToHM(timeTracking?.regular_minutes)}</span> : <span className={`${styles.dh}`}>—</span>}
        </td>

        <td className={`${styles.td}`}>
            {timeTracking?.approved_ot_time > 0 ? <span className={`${styles.dh}`}>{formatMinutesToHM(timeTracking?.approved_ot_time)}</span> : <span className={`${styles.dh}`}>—</span>}
        </td>

        <td className={`${styles.td}`}>
            {wageTotal > 0 ? <span className={`${styles.dh}`}>{new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(wageTotal)}</span> : <span className={`${styles.dh}`}>—</span>}
        </td>

        <td className={`${styles.td}`}>{statusEl}</td>
    </tr>);
}

const DayViewTable = ({ contentLoading, filteredData, setLoading, updateTimeTracking }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedEmp, setSelectedEmp] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);

    return (<div className={`${styles.tblWrap}`}>
        {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

        {!contentLoading && filteredData?.length > 0 && <table className={`${styles.table}`}>
            <thead>
                <tr className={`${styles.dvThead}`}>
                    <th className={`${styles.thEc}`}>Employee</th>
                    <th className={`${styles.th}`}>Clock in</th>
                    <th className={`${styles.th}`}>Clock out</th>
                    <th className={`${styles.th}`}>Lunch Break</th>
                    <th className={`${styles.th}`}>Regular Hrs</th>
                    <th className={`${styles.th}`}>OT Hrs</th>
                    <th className={`${styles.th}`}>Wage</th>
                    <th className={`${styles.th}`}>Status</th>
                </tr>
            </thead>
            <tbody>
                {filteredData.map((item, index) => (
                    <DayViewRow key={item?.id} index={index} item={item} setIsModalOpen={setIsModalOpen.bind(this)} setSelectedEmp={setSelectedEmp.bind(this)} setSelectedDay={setSelectedDay.bind(this)} />
                ))}
            </tbody>
        </table>}

        {filteredData?.length === 0 && <>
            <div className={`${styles.hrBody}`}>
                <div className={`${styles.panel} ${styles.panelEmpty}`}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" style={{ color: "#ccc", marginBottom: 10 }} aria-hidden="true">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                        <line x1="4" y1="4" x2="20" y2="20" />
                    </svg>
                    <div className={`${styles.emptyTitle}`}>Time tracking records unavailable.</div>
                    <div className={`${styles.emptySub}`}>Time entries will appear here once tracking starts.</div>
                </div>
            </div>
        </>}


        {isModalOpen && (<DayModal setIsModalOpen={setIsModalOpen.bind(this)} selectedEmp={selectedEmp} selectedDay={selectedDay} setLoading={setLoading.bind(this)} updateTimeTracking={updateTimeTracking.bind(this)} />)}
    </div>);
}

export default DayViewTable;